import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import cs from 'classnames';


@inject('lineStore', 'dictStore')
@observer
class SecondaryStatisticalCategories extends Component {
  handleSelect = (categoryID) => {
    this.props.lineStore.line.selectSecondaryStatisticalCategory(this.props.gameID, categoryID);
  }

  render() {
    const { gameID, dictStore: { getLang } } = this.props;
    const lineStore = this.props.lineStore.line;
    const statisticalCategories = lineStore.statisticalCategories.get(gameID);
    const secondaryCategories = lineStore.getSecondaryStatisticalCategories(statisticalCategories);

    return secondaryCategories.map(({ id, name, isActive, count, isLocaleKey }) => {
      if (count === 0) {
        return null;
      }

      return (
        <div
          className={cs('g-a-c-i', { 'g-a-c-i-s': isActive })}
          onClick={() => this.handleSelect(id)}
        >
          <span>
            {isLocaleKey ? getLang(name) : name}
            {!!count && <span className="g-a-c-i-t-c">{count}</span>}
          </span>
        </div>
      );
    });
  }
}

export default SecondaryStatisticalCategories;



// WEBPACK FOOTER //
// ./src/components/line/additionalCategories/SecondaryStatisticalCategories.jsx